import React from "react";
import {
    Menu, Image,
    Space, Dropdown, Tooltip
} from "antd";
import {
    UserOutlined, InfoCircleOutlined
} from '@ant-design/icons';
import '../CSS/style-guide.css'
import { SignOutButton } from "./AuthButton";
import { useMsal } from "@azure/msal-react";
import { VscFeedback } from "react-icons/vsc";

// HeaderJs component for displaying the header of the application
// It includes the application logo, name, user profile information, and a privacy information notice
const HeaderJs = () => {
    const { accounts } = useMsal();
    const user = accounts[0];
    const feedbackForm = 'https://atos365.sharepoint.com/:l:/s/SupplierContractAnalysisGenAI/FCuMX7ZKWitOsEecntCTCDcBH3T3kUJWi8PRa97UGS5dzQ?nav=MDE4MWRlMzEtZGY1ZS00NDFhLWJiNTgtMmRhODBkNjkxZWQw'


    const infoUrl = "https://atos365.sharepoint.com/:b:/r/sites/100001504/Process%20and%20Policies/10%20Published/SCIA%20Privacy%20Information%20Notice%20V1.0.pdf?csf=1&web=1&e=n7ydWM";

    // Profile menu for displaying user information and logout option
    // It includes the user's name, email, and a logout button
    const profile = (
        <Menu>
            <Menu.Item key="1">Name: {user?.name}</Menu.Item>
            <Menu.Item key="2">Email: {user?.username}</Menu.Item>
            <Menu.Divider />
            <Menu.Item key="3"><SignOutButton /></Menu.Item>
        </Menu>
    );

    return (
        <>
            <div className="application" >
                <div class="atos">
                    <Image className="atos-logo" width={100} height={100}
                        src="../Image/Atos.svg" />
                </div>
                <div class="app-separator"><span>|</span></div>
                <div class="app-name">
                    <a href><span>Supplier Contract Insights & Analytics</span></a>
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
                <Tooltip title="Provide your feedback">
                    <VscFeedback
                        style={{ fontSize: '20px', color: 'white', cursor: 'pointer' }}
                        onClick={() => window.open(feedbackForm, '_blank')}
                    />
                </Tooltip>
                <Tooltip title="Privacy Information Notice">
                    <InfoCircleOutlined
                        onClick={() => window.open(infoUrl, '_blank')}
                        style={{ fontSize: '20px', color: 'white', cursor: 'pointer' }}
                    />
                </Tooltip>
                <Dropdown overlay={profile}>
                    <a href onClick={e => e.preventDefault()}>
                        <Space>
                            <UserOutlined style={{ fontSize: '20px', color: 'white' }} />
                        </Space>
                    </a>
                </Dropdown>
            </div>
        </>
    );
}

export default HeaderJs;